export default __webpack_public_path__ + "static/media/nestjs-icon.cd4028c7.svg";